// Custom elements also initialize when collection results insert fresh promo markup.
class PlpPromoVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.playbackDisabled = this.motion.matches;
    this.visible = false;
    this.video.muted = true;
    this.video.addEventListener('error', () => {
      this.playbackDisabled = true;
    }, options);
    this.motion.addEventListener('change', () => {
      this.playbackDisabled = this.motion.matches;
      this.updatePlayback();
    }, options);
    document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.updatePlayback();
    }, { threshold: 0 });
    this.observer.observe(this);
  }

  updatePlayback() {
    if (this.visible && !document.hidden && !this.playbackDisabled) {
      // Keep the poster visible if the browser declines autoplay.
      this.video.play().catch(() => {});
    } else {
      this.video.pause();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.events?.abort();
    this.video?.pause();
  }
}

if (!customElements.get('plp-promo-video')) {
  customElements.define('plp-promo-video', PlpPromoVideo);
}
